import { ENTERPRISE_CORE_SEAT, ONBOARDING_HSOC_CORE_SEATS_ENTERPRISE, ONBOARDING_HSOC_CORE_SEATS_PROFESSIONAL, ONBOARDING_HSOC_FRONT_OFFICE_SEATS_ENTERPRISE, ONBOARDING_HSOC_FRONT_OFFICE_SEATS_PROFESSIONAL, PROFESSIONAL_CORE_SEAT } from '../scopeConstants';
export const getHasCoreEnterpriseSeat = scopes => {
  return scopes.includes(ENTERPRISE_CORE_SEAT);
};
export const getHasCoreProSeat = scopes => {
  return scopes.includes(PROFESSIONAL_CORE_SEAT);
};
export const getHasHsocCoreSeatsPro = scopes => {
  return scopes.includes(ONBOARDING_HSOC_CORE_SEATS_PROFESSIONAL);
};
export const getHasHsocCoreSeatsEnterprise = scopes => {
  return scopes.includes(ONBOARDING_HSOC_CORE_SEATS_ENTERPRISE);
};
export const getHasHsocFrontOfficeSeatsPro = scopes => {
  return scopes.includes(ONBOARDING_HSOC_FRONT_OFFICE_SEATS_PROFESSIONAL);
};
export const getHasHsocFrontOfficeSeatsEnterprise = scopes => {
  return scopes.includes(ONBOARDING_HSOC_FRONT_OFFICE_SEATS_ENTERPRISE);
};